import { render, staticRenderFns } from "./Bhkccx.vue?vue&type=template&id=451f8f2a&scoped=true&"
import script from "./Bhkccx.vue?vue&type=script&lang=js&"
export * from "./Bhkccx.vue?vue&type=script&lang=js&"
import style0 from "./Bhkccx.vue?vue&type=style&index=0&id=451f8f2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f8f2a",
  null
  
)

export default component.exports